import React from 'react';
import { MapPin, Mail } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const DIRECTIONS_URL = "https://www.google.com/maps/dir/?api=1&destination=16.912904,-24.964312";

const ContactInfo = () => {
  const { t } = useLanguage();

  return (
    <div className="space-y-8">
      {/* Address */}
      <div className="flex items-start gap-4">
        <div className="w-10 h-10 flex items-center justify-center bg-black/10">
          <MapPin size={18} className="text-black" />
        </div>
        <div>
          <h4 className="text-black font-medium mb-1">Hotel Respiro</h4>
          <p className="text-black/70 font-light text-sm text-justify">
            {t('contact.address')}
          </p>
        </div>
      </div>

      {/* Email */}
      <div className="flex items-start gap-4">
        <div className="w-10 h-10 flex items-center justify-center bg-black/10">
          <Mail size={18} className="text-black" />
        </div>
        <div>
          <h4 className="text-black font-medium mb-1">Email</h4>
          <a 
            href={`mailto:${t('contact.email')}`}
            className="text-black/70 font-light text-sm hover:text-black transition-colors duration-300"
          >
            {t('contact.email')}
          </a>
        </div>
      </div>

      {/* Get Directions Link */}
      <div className="mt-4">
        <a 
          href={DIRECTIONS_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-6 py-3 border border-black/30 text-black uppercase tracking-[0.15em] text-xs font-medium hover:bg-black hover:text-white transition-all duration-300"
        >
          <MapPin size={14} />
          Get Directions
        </a>
      </div>
    </div>
  );
};

export default ContactInfo;
